import { BaseError } from '@kiplin/web-common/error';
import type { CommunicationKitFormat } from '@client/feature/communication-kit/domain/constant/communication-kit-format.constant';

export class MissingCommunicationKitFormatError extends BaseError {
  constructor(format: CommunicationKitFormat) {
    super('4b2567fe-06f9-4b57-b8f2-02ec1e8dbd3c', `Missing communication kit format configuration for "${format}".`);
  }
}
